<template>
  <div>
    <div class="foot wow animated fadeInUp" data-wow-duration="2s">
      <div class="left">
        <p>全国统一投诉服务热线</p>
        <p>010-65923221</p>
        <p>总部地址：北京朝阳区青年路达美中心T2栋10层</p>
        <p>阳光恒昌物业服务股份有限公司 版权所有</p>
        <a href="https://beian.miit.gov.cn/" target="_blank">新ICP备16000887号</a>
      </div>
      <div class="right">
        <p>关注安立方物业说</p>
        <img src="../assets/image/qrcode.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.foot {
  width: 80%;
  margin: 90px auto 77px auto;
  display: flex;
  justify-content: space-between;
  .left {
    text-align: start;
    p:nth-child(1) {
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #666666;
    }
    p:nth-child(2) {
      font-size: 30px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: #333333;
      line-height: 58px;
    }
    p:nth-child(3) {
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: rgba(77, 77, 77, 1);
      // line-height: 39px;
    }
    p:nth-child(4) {
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: rgba(77, 77, 77, 1);
      line-height: 39px;
    }
  }
  .right {
      display: flex;
      align-items: center;
    p {
      float: left;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: #333333;
      line-height: 58px;
    }
    img {
      float: left;
      margin-left: 20px;
    }
  }
}

@media screen and (max-width: 1000px) {
  .foot{
    flex-direction: column;
    .left,.right{
      width: 100%;
    }
    .left{
      p:nth-child(3),p:nth-child(4){
        font-size: 14px;
      }
    }
    .right{
      flex-direction: column;
      img{
        margin-left: 0;
      }
    }
  }
}
</style>
